import React, { useState } from "react";
import NavBar from "./navbar";
import Footer from "./footer";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import $ from "jquery";
import "./css/home.css";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";
import quality from "../assets/quality-assurance.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import Whatsapp from "./whatsapp";
function Home() {
  const [currentSlide, updateSlide] = useState(0);
  function nextSlide() {
    updateSlide(currentSlide + 1);
  }
  function prevslide() {
    updateSlide(currentSlide - 1);
  }
  function UpdateCurrentSlide(index) {
    updateSlide(index);
  }
  return (
    <>
      <NavBar home={true} />
      <canvas className="canvas-home"></canvas>
      <div className="home-container">
        <div className="home-box">
          <TextCarousel
            currentSlide={currentSlide}
            update={UpdateCurrentSlide}
            className="textcarousel"
          />
          <div className="box-info">
            <div className="box-info-item">
              <img src={quality} alt="ql" />
              <h2>Quality-Tested Products</h2>
            </div>
            <div className="box-info-item">
              <svg
                id="Group_2249"
                data-name="Group 2249"
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 30 30"
              >
                <g id="Group_29" data-name="Group 29">
                  <path
                    id="Path_32"
                    data-name="Path 32"
                    fill="#fff"
                    d="M.316,30A.313.313,0,0,1,0,29.684V27.658a.313.313,0,0,1,.316-.316h.7V2.658h-.7A.313.313,0,0,1,0,2.342V.316A.313.313,0,0,1,.316,0h16.2a.313.313,0,0,1,.316.316V2.342a.313.313,0,0,1-.316.316h-.7v4.43H29.684A.313.313,0,0,1,30,7.405V9.43a.313.313,0,0,1-.316.316h-.7V27.342h.7a.313.313,0,0,1,.316.316v2.025a.313.313,0,0,1-.316.316Zm.316-.633H29.367V27.975H.633Zm23.481-8.1a.313.313,0,0,1,.316.316v5.759h3.924V9.747H14.81V27.342h3.924V21.582a.313.313,0,0,1,.316-.316Zm-4.747,6.076H23.8V21.9h-4.43Zm-17.722,0H14.177V9.747h-.7a.313.313,0,0,1-.316-.316V7.405a.313.313,0,0,1,.316-.316H15.19V2.658H1.646ZM13.8,9.114h15.57V7.722H13.8ZM.633,2.025H16.2V.633H.633Z"
                  ></path>
                </g>
                <g
                  id="Group_30"
                  data-name="Group 30"
                  transform="translate(4.051 4.051)"
                >
                  <path
                    id="Path_33"
                    data-name="Path 33"
                    fill="#fff"
                    d="M64.316,67.671A.313.313,0,0,1,64,67.354V64.316A.313.313,0,0,1,64.316,64h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405V64.633H64.633Z"
                    transform="translate(-64 -64)"
                  ></path>
                </g>
                <g
                  id="Group_31"
                  data-name="Group 31"
                  transform="translate(9.114 4.051)"
                >
                  <path
                    id="Path_34"
                    data-name="Path 34"
                    fill="#fff"
                    d="M144.316,67.671a.313.313,0,0,1-.316-.316V64.316a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405V64.633h-2.405Z"
                    transform="translate(-144 -64)"
                  ></path>
                </g>
                <g
                  id="Group_32"
                  data-name="Group 32"
                  transform="translate(4.051 10.127)"
                >
                  <path
                    id="Path_35"
                    data-name="Path 35"
                    fill="#fff"
                    d="M64.316,163.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405H64.633Z"
                    transform="translate(-64 -160)"
                  ></path>
                </g>
                <g
                  id="Group_33"
                  data-name="Group 33"
                  transform="translate(9.114 10.127)"
                >
                  <path
                    id="Path_36"
                    data-name="Path 36"
                    fill="#fff"
                    d="M144.316,163.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                    transform="translate(-144 -160)"
                  ></path>
                </g>
                <g
                  id="Group_34"
                  data-name="Group 34"
                  transform="translate(4.051 16.203)"
                >
                  <path
                    id="Path_37"
                    data-name="Path 37"
                    fill="#fff"
                    d="M64.316,259.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405H64.633Z"
                    transform="translate(-64 -256)"
                  ></path>
                </g>
                <g
                  id="Group_35"
                  data-name="Group 35"
                  transform="translate(9.114 16.203)"
                >
                  <path
                    id="Path_38"
                    data-name="Path 38"
                    fill="#fff"
                    d="M144.316,259.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                    transform="translate(-144 -256)"
                  ></path>
                </g>
                <g
                  id="Group_36"
                  data-name="Group 36"
                  transform="translate(4.051 22.278)"
                >
                  <path
                    id="Path_39"
                    data-name="Path 39"
                    fill="#fff"
                    d="M64.316,355.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405H64.633Z"
                    transform="translate(-64 -352)"
                  ></path>
                </g>
                <g
                  id="Group_37"
                  data-name="Group 37"
                  transform="translate(9.114 22.278)"
                >
                  <path
                    id="Path_40"
                    data-name="Path 40"
                    fill="#fff"
                    d="M144.316,355.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                    transform="translate(-144 -352)"
                  ></path>
                </g>
                <g
                  id="Group_38"
                  data-name="Group 38"
                  transform="translate(17.215 11.139)"
                >
                  <path
                    id="Path_41"
                    data-name="Path 41"
                    fill="#fff"
                    d="M272.316,179.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                    transform="translate(-272 -176)"
                  ></path>
                </g>
                <g
                  id="Group_39"
                  data-name="Group 39"
                  transform="translate(22.278 11.139)"
                >
                  <path
                    id="Path_42"
                    data-name="Path 42"
                    fill="#fff"
                    d="M352.316,179.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                    transform="translate(-352 -176)"
                  ></path>
                </g>
                <g
                  id="Group_40"
                  data-name="Group 40"
                  transform="translate(17.215 16.203)"
                >
                  <path
                    id="Path_43"
                    data-name="Path 43"
                    fill="#fff"
                    d="M272.316,259.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                    transform="translate(-272 -256)"
                  ></path>
                </g>
                <g
                  id="Group_41"
                  data-name="Group 41"
                  transform="translate(22.278 16.203)"
                >
                  <path
                    id="Path_44"
                    data-name="Path 44"
                    fill="#fff"
                    d="M352.316,259.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                    transform="translate(-352 -256)"
                  ></path>
                </g>
              </svg>
              <h2>23 Years Of Experience</h2>
            </div>
            <div className="box-info-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="31.008"
                data-name="Group 28"
                viewBox="0 0 31 31.008"
              >
                <path
                  d="M150.4 6.662A6.662 6.662 0 1 0 157.062 0a6.672 6.672 0 0 0-6.662 6.662zm12.106 0a5.451 5.451 0 1 1-5.451-5.451 5.457 5.457 0 0 1 5.451 5.451zm0 0"
                  fill="#fff"
                  data-name="Path 29"
                  transform="translate(-139.012)"
                ></path>
                <path
                  d="M6.949 187.839a.608.608 0 0 0 .855.008l2.937-2.892a1.825 1.825 0 0 0 .432-1.878l.628-.606a1.819 1.819 0 0 1 1.264-.507h8.048a5.4 5.4 0 0 0 3.8-1.544c.045-.038-.318.386 5.489-6.564a2.422 2.422 0 0 0-3.687-3.142l-3.573 3.672a2.442 2.442 0 0 0-1.885-.9h-6.744a7.845 7.845 0 0 0-3.036-.606 7.5 7.5 0 0 0-6.829 3.869 1.834 1.834 0 0 0-1.62.5L.151 180.14a.608.608 0 0 0 0 .855zm4.535-13.756a6.667 6.667 0 0 1 2.665.553.663.663 0 0 0 .242.053h6.874a1.211 1.211 0 0 1 0 2.423h-4.943a.606.606 0 1 0 0 1.211h4.944a2.43 2.43 0 0 0 2.423-2.423 2.246 2.246 0 0 0-.023-.318c3.46-3.551 3.944-4.05 3.967-4.081a1.214 1.214 0 1 1 1.855 1.567l-5.436 6.5a4.2 4.2 0 0 1-2.937 1.181h-8.048a3.031 3.031 0 0 0-2.1.848l-.515.5-4.752-4.75a6.276 6.276 0 0 1 5.784-3.263zM3.891 178.1a.606.606 0 0 1 .749-.083c.106.061-.2-.212 5.246 5.224a.608.608 0 0 1 0 .855l-2.506 2.468-5.951-6zm0 0"
                  fill="#fff"
                  data-name="Path 30"
                  transform="translate(.025 -157.012)"
                ></path>
                <path
                  d="M213.4 32.606v.712a1.816 1.816 0 0 0 .6 3.527.606.606 0 0 1 0 1.211 1.084 1.084 0 0 1-.787-.462.607.607 0 0 0-.931.78 2.523 2.523 0 0 0 1.105.787v.7a.606.606 0 1 0 1.211 0v-.712a1.816 1.816 0 0 0-.598-3.523.606.606 0 0 1 0-1.211.977.977 0 0 1 .659.318.605.605 0 1 0 .84-.871 2.468 2.468 0 0 0-.893-.56v-.7a.6.6 0 1 0-1.2 0zm0 0"
                  fill="#fff"
                  data-name="Path 31"
                  transform="translate(-196.083 -29.577)"
                ></path>
              </svg>
              <h2>Competitive Prices</h2>
            </div>
            <div className="box-info-item">
              <svg
                id="Group_2245"
                data-name="Group 2245"
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 40.225 26.711"
              >
                <g
                  id="Group_621"
                  data-name="Group 621"
                  transform="translate(0)"
                >
                  <path
                    id="Path_15"
                    data-name="Path 15"
                    fill="#fff"
                    d="M34.471,19.452l-2.185-.627a.226.226,0,0,1-.162-.211v-.726a3.971,3.971,0,0,0,.507-.416,3.885,3.885,0,0,0,1.191-2.812V13.652l.211-.423a3.357,3.357,0,0,0,.352-1.5V9.007a.532.532,0,0,0-.529-.529H28.769a3.363,3.363,0,0,0-3.355,3.355v.028a2.753,2.753,0,0,0,.3,1.247l.268.543v.867a4.126,4.126,0,0,0,1.7,3.334v.761c0,.12,0,.169-.437.289l-1.064.3L23.1,18.085a.5.5,0,0,0-.141-.4l-.987-1.036V14.913c.106-.085.2-.176.3-.268a6.2,6.2,0,0,0,1.952-4.511V8.746a6.132,6.132,0,0,0,.564-2.572V.529A.532.532,0,0,0,24.259,0H16.351A5.058,5.058,0,0,0,11.3,5.053V6.181a6.156,6.156,0,0,0,.564,2.572V9.945a6.454,6.454,0,0,0,2.262,4.926v1.776l-.987,1.036a.516.516,0,0,0-.141.4L9.747,19.269a2.772,2.772,0,0,0-.655.345l-.507-.254a3.983,3.983,0,0,0,2.023-1.642.508.508,0,0,0,0-.472,9.352,9.352,0,0,1-.465-3.284c-.014-.374-.021-.726-.049-1.043A4.6,4.6,0,0,0,5.61,8.472a4.593,4.593,0,0,0-4.482,4.447c-.021.317-.035.67-.049,1.043a9.4,9.4,0,0,1-.465,3.284.508.508,0,0,0,0,.472,3.99,3.99,0,0,0,2.03,1.635l-1.417.712A2.221,2.221,0,0,0,0,22.06v3.9a.532.532,0,0,0,.529.529.532.532,0,0,0,.529-.529v-3.9a1.155,1.155,0,0,1,.648-1.043l1.769-.881.613.585a2.214,2.214,0,0,0,3.059,0l.613-.585.578.289A2.822,2.822,0,0,0,7.915,21.9v4.067a.529.529,0,1,0,1.057,0V21.9a1.735,1.735,0,0,1,1.142-1.628l3.432-1.247,1.431,2.143a1.068,1.068,0,0,0,.8.479.534.534,0,0,0,.106.007,1.111,1.111,0,0,0,.775-.317l.874-.874v5.5a.529.529,0,1,0,1.057,0v-5.5l.874.874a1.1,1.1,0,0,0,.775.317.534.534,0,0,0,.106-.007,1.124,1.124,0,0,0,.8-.479l1.431-2.143,3.432,1.247A1.735,1.735,0,0,1,27.155,21.9v4.067a.529.529,0,1,0,1.057,0V21.9a2.772,2.772,0,0,0-.782-1.931l.134-.035a3.043,3.043,0,0,0,.493-.176L29.4,21.1v4.87a.529.529,0,0,0,1.057,0V21.1L31.8,19.762a2.152,2.152,0,0,0,.226.092l2.185.627a1.169,1.169,0,0,1,.846,1.121v4.37a.529.529,0,1,0,1.057,0V21.6A2.29,2.29,0,0,0,34.471,19.452Zm-26.634-.93v-.627a3.927,3.927,0,0,0,1.4-1.72,5.514,5.514,0,0,0,.3,1.262A3.974,3.974,0,0,1,7.837,18.522ZM2.185,13a3.919,3.919,0,0,1,1.071-2.467,3.285,3.285,0,0,1,4.722,0A3.957,3.957,0,0,1,9.049,13c.021.3.035.634.042,1V14.1a4.79,4.79,0,0,0-2.608-1.91,6.721,6.721,0,0,0-2.009-.317.549.549,0,0,0-.366.162l-.951.987a.528.528,0,0,0,.761.733l.8-.825c.684.035,2.883.289,3.735,2.171a2.861,2.861,0,0,1-5.688-.444.532.532,0,0,0-.529-.529.343.343,0,0,0-.085.007A.853.853,0,0,1,2.157,14C2.157,13.638,2.164,13.292,2.185,13Zm-.493,4.426a6.081,6.081,0,0,0,.3-1.269,3.927,3.927,0,0,0,1.4,1.72v.634A3.781,3.781,0,0,1,1.691,17.429Zm3.122,2.516L4.32,19.48a1.07,1.07,0,0,0,.127-.514V18.4a3.972,3.972,0,0,0,2.34,0v.564a1.07,1.07,0,0,0,.127.514l-.493.465A1.162,1.162,0,0,1,4.814,19.945Zm8.112-10V8.634a.688.688,0,0,0-.049-.233,5.1,5.1,0,0,1-.514-2.22V5.053a4,4,0,0,1,4-4h7.386V6.181A5,5,0,0,1,23.23,8.4a.511.511,0,0,0-.049.233v1.508a5.065,5.065,0,0,1-1.621,3.735c-.134.12-.268.24-.409.345l-.007.007a5.084,5.084,0,0,1-3.432,1.022A5.242,5.242,0,0,1,12.926,9.945ZM17.641,16.3c.141.007.275.014.416.014a6.125,6.125,0,0,0,2.854-.7v.966L18.05,18.536l-2.861-1.959V15.59A5.826,5.826,0,0,0,17.641,16.3ZM15.9,20.58c-.007.007-.014.014-.028.007s-.021-.014-.028-.014L14.2,18.106l.529-.557,2.495,1.706Zm4.356-.007c0,.007-.007.014-.028.014a.073.073,0,0,1-.028-.007l-1.325-1.325,2.495-1.706.529.557Zm6.787-6.054v-.987a.569.569,0,0,0-.056-.24l-.324-.655a1.742,1.742,0,0,1-.183-.775v-.028a2.3,2.3,0,0,1,2.3-2.3h4.56v2.192a2.37,2.37,0,0,1-.24,1.029l-.268.536a.545.545,0,0,0-.056.24V14.66a2.853,2.853,0,0,1-2.946,2.854A2.955,2.955,0,0,1,27.043,14.519Zm2.742,4.06h.12a4.007,4.007,0,0,0,1.163-.176v.211a1.493,1.493,0,0,0,.035.31L29.9,20.129l-1.2-1.2a1.406,1.406,0,0,0,.035-.317v-.226A3.783,3.783,0,0,0,29.784,18.578Z"
                    transform="translate(2.235)"
                  ></path>
                  <line
                    id="Line_6"
                    data-name="Line 6"
                    stroke="#fff"
                    x2="40.225"
                    transform="translate(0 26.211)"
                  ></line>
                </g>
              </svg>
              <h2>Authorised Dealership</h2>
            </div>
          </div>
        </div>
        <div className="carousel-container">
          <Maincarousel
            currentSlide={currentSlide}
            update={UpdateCurrentSlide}
          />
          <div className="button-column-carousel">
            <button className="carousel-button" onClick={nextSlide}>
              <svg
                width="50"
                height="55"
                viewBox="0 0 74 74"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="37"
                  cy="37"
                  r="35"
                  fill="white"
                  stroke="#8C8C8C"
                  stroke-width="4"
                />
                <line
                  x1="29.0607"
                  y1="15.9393"
                  x2="49.6729"
                  y2="36.5516"
                  stroke="black"
                  stroke-width="3"
                />
                <line
                  x1="28.3458"
                  y1="55.9393"
                  x2="48.958"
                  y2="35.3271"
                  stroke="black"
                  stroke-width="3"
                />
              </svg>
            </button>
            <button className="carousel-button" onClick={prevslide}>
              <svg
                width="55"
                height="55"
                viewBox="0 0 74 74"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="37"
                  cy="37"
                  r="35"
                  fill="white"
                  stroke="#8C8C8C"
                  stroke-width="4"
                />
                <line
                  y1="-1.5"
                  x2="29.1501"
                  y2="-1.5"
                  transform="matrix(-0.707107 0.707107 0.707107 0.707107 47.0187 18)"
                  stroke="black"
                  stroke-width="3"
                />
                <line
                  y1="-1.5"
                  x2="29.1501"
                  y2="-1.5"
                  transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 45.6122 58)"
                  stroke="black"
                  stroke-width="3"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="box-info1">
          <div className="box-info-item1">
            <img src={quality} alt="ql" />
            <h2>Quality-Tested Products</h2>
          </div>
          <div className="box-info-item1">
            <svg
              id="Group_2249"
              data-name="Group 2249"
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="50"
              viewBox="0 0 30 30"
            >
              <g id="Group_29" data-name="Group 29">
                <path
                  id="Path_32"
                  data-name="Path 32"
                  fill="#fff"
                  d="M.316,30A.313.313,0,0,1,0,29.684V27.658a.313.313,0,0,1,.316-.316h.7V2.658h-.7A.313.313,0,0,1,0,2.342V.316A.313.313,0,0,1,.316,0h16.2a.313.313,0,0,1,.316.316V2.342a.313.313,0,0,1-.316.316h-.7v4.43H29.684A.313.313,0,0,1,30,7.405V9.43a.313.313,0,0,1-.316.316h-.7V27.342h.7a.313.313,0,0,1,.316.316v2.025a.313.313,0,0,1-.316.316Zm.316-.633H29.367V27.975H.633Zm23.481-8.1a.313.313,0,0,1,.316.316v5.759h3.924V9.747H14.81V27.342h3.924V21.582a.313.313,0,0,1,.316-.316Zm-4.747,6.076H23.8V21.9h-4.43Zm-17.722,0H14.177V9.747h-.7a.313.313,0,0,1-.316-.316V7.405a.313.313,0,0,1,.316-.316H15.19V2.658H1.646ZM13.8,9.114h15.57V7.722H13.8ZM.633,2.025H16.2V.633H.633Z"
                ></path>
              </g>
              <g
                id="Group_30"
                data-name="Group 30"
                transform="translate(4.051 4.051)"
              >
                <path
                  id="Path_33"
                  data-name="Path 33"
                  fill="#fff"
                  d="M64.316,67.671A.313.313,0,0,1,64,67.354V64.316A.313.313,0,0,1,64.316,64h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405V64.633H64.633Z"
                  transform="translate(-64 -64)"
                ></path>
              </g>
              <g
                id="Group_31"
                data-name="Group 31"
                transform="translate(9.114 4.051)"
              >
                <path
                  id="Path_34"
                  data-name="Path 34"
                  fill="#fff"
                  d="M144.316,67.671a.313.313,0,0,1-.316-.316V64.316a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405V64.633h-2.405Z"
                  transform="translate(-144 -64)"
                ></path>
              </g>
              <g
                id="Group_32"
                data-name="Group 32"
                transform="translate(4.051 10.127)"
              >
                <path
                  id="Path_35"
                  data-name="Path 35"
                  fill="#fff"
                  d="M64.316,163.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405H64.633Z"
                  transform="translate(-64 -160)"
                ></path>
              </g>
              <g
                id="Group_33"
                data-name="Group 33"
                transform="translate(9.114 10.127)"
              >
                <path
                  id="Path_36"
                  data-name="Path 36"
                  fill="#fff"
                  d="M144.316,163.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                  transform="translate(-144 -160)"
                ></path>
              </g>
              <g
                id="Group_34"
                data-name="Group 34"
                transform="translate(4.051 16.203)"
              >
                <path
                  id="Path_37"
                  data-name="Path 37"
                  fill="#fff"
                  d="M64.316,259.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405H64.633Z"
                  transform="translate(-64 -256)"
                ></path>
              </g>
              <g
                id="Group_35"
                data-name="Group 35"
                transform="translate(9.114 16.203)"
              >
                <path
                  id="Path_38"
                  data-name="Path 38"
                  fill="#fff"
                  d="M144.316,259.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                  transform="translate(-144 -256)"
                ></path>
              </g>
              <g
                id="Group_36"
                data-name="Group 36"
                transform="translate(4.051 22.278)"
              >
                <path
                  id="Path_39"
                  data-name="Path 39"
                  fill="#fff"
                  d="M64.316,355.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405H64.633Z"
                  transform="translate(-64 -352)"
                ></path>
              </g>
              <g
                id="Group_37"
                data-name="Group 37"
                transform="translate(9.114 22.278)"
              >
                <path
                  id="Path_40"
                  data-name="Path 40"
                  fill="#fff"
                  d="M144.316,355.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                  transform="translate(-144 -352)"
                ></path>
              </g>
              <g
                id="Group_38"
                data-name="Group 38"
                transform="translate(17.215 11.139)"
              >
                <path
                  id="Path_41"
                  data-name="Path 41"
                  fill="#fff"
                  d="M272.316,179.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                  transform="translate(-272 -176)"
                ></path>
              </g>
              <g
                id="Group_39"
                data-name="Group 39"
                transform="translate(22.278 11.139)"
              >
                <path
                  id="Path_42"
                  data-name="Path 42"
                  fill="#fff"
                  d="M352.316,179.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                  transform="translate(-352 -176)"
                ></path>
              </g>
              <g
                id="Group_40"
                data-name="Group 40"
                transform="translate(17.215 16.203)"
              >
                <path
                  id="Path_43"
                  data-name="Path 43"
                  fill="#fff"
                  d="M272.316,259.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                  transform="translate(-272 -256)"
                ></path>
              </g>
              <g
                id="Group_41"
                data-name="Group 41"
                transform="translate(22.278 16.203)"
              >
                <path
                  id="Path_44"
                  data-name="Path 44"
                  fill="#fff"
                  d="M352.316,259.671a.313.313,0,0,1-.316-.316v-3.038a.313.313,0,0,1,.316-.316h3.038a.313.313,0,0,1,.316.316v3.038a.313.313,0,0,1-.316.316Zm.316-.633h2.405v-2.405h-2.405Z"
                  transform="translate(-352 -256)"
                ></path>
              </g>
            </svg>
            <h2>23 Years Of Experience</h2>
          </div>
          <div className="box-info-item1">
            <svg
              id="Group_2245"
              data-name="Group 2245"
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="50"
              viewBox="0 0 40.225 26.711"
            >
              <g id="Group_621" data-name="Group 621" transform="translate(0)">
                <path
                  id="Path_15"
                  data-name="Path 15"
                  fill="#fff"
                  d="M34.471,19.452l-2.185-.627a.226.226,0,0,1-.162-.211v-.726a3.971,3.971,0,0,0,.507-.416,3.885,3.885,0,0,0,1.191-2.812V13.652l.211-.423a3.357,3.357,0,0,0,.352-1.5V9.007a.532.532,0,0,0-.529-.529H28.769a3.363,3.363,0,0,0-3.355,3.355v.028a2.753,2.753,0,0,0,.3,1.247l.268.543v.867a4.126,4.126,0,0,0,1.7,3.334v.761c0,.12,0,.169-.437.289l-1.064.3L23.1,18.085a.5.5,0,0,0-.141-.4l-.987-1.036V14.913c.106-.085.2-.176.3-.268a6.2,6.2,0,0,0,1.952-4.511V8.746a6.132,6.132,0,0,0,.564-2.572V.529A.532.532,0,0,0,24.259,0H16.351A5.058,5.058,0,0,0,11.3,5.053V6.181a6.156,6.156,0,0,0,.564,2.572V9.945a6.454,6.454,0,0,0,2.262,4.926v1.776l-.987,1.036a.516.516,0,0,0-.141.4L9.747,19.269a2.772,2.772,0,0,0-.655.345l-.507-.254a3.983,3.983,0,0,0,2.023-1.642.508.508,0,0,0,0-.472,9.352,9.352,0,0,1-.465-3.284c-.014-.374-.021-.726-.049-1.043A4.6,4.6,0,0,0,5.61,8.472a4.593,4.593,0,0,0-4.482,4.447c-.021.317-.035.67-.049,1.043a9.4,9.4,0,0,1-.465,3.284.508.508,0,0,0,0,.472,3.99,3.99,0,0,0,2.03,1.635l-1.417.712A2.221,2.221,0,0,0,0,22.06v3.9a.532.532,0,0,0,.529.529.532.532,0,0,0,.529-.529v-3.9a1.155,1.155,0,0,1,.648-1.043l1.769-.881.613.585a2.214,2.214,0,0,0,3.059,0l.613-.585.578.289A2.822,2.822,0,0,0,7.915,21.9v4.067a.529.529,0,1,0,1.057,0V21.9a1.735,1.735,0,0,1,1.142-1.628l3.432-1.247,1.431,2.143a1.068,1.068,0,0,0,.8.479.534.534,0,0,0,.106.007,1.111,1.111,0,0,0,.775-.317l.874-.874v5.5a.529.529,0,1,0,1.057,0v-5.5l.874.874a1.1,1.1,0,0,0,.775.317.534.534,0,0,0,.106-.007,1.124,1.124,0,0,0,.8-.479l1.431-2.143,3.432,1.247A1.735,1.735,0,0,1,27.155,21.9v4.067a.529.529,0,1,0,1.057,0V21.9a2.772,2.772,0,0,0-.782-1.931l.134-.035a3.043,3.043,0,0,0,.493-.176L29.4,21.1v4.87a.529.529,0,0,0,1.057,0V21.1L31.8,19.762a2.152,2.152,0,0,0,.226.092l2.185.627a1.169,1.169,0,0,1,.846,1.121v4.37a.529.529,0,1,0,1.057,0V21.6A2.29,2.29,0,0,0,34.471,19.452Zm-26.634-.93v-.627a3.927,3.927,0,0,0,1.4-1.72,5.514,5.514,0,0,0,.3,1.262A3.974,3.974,0,0,1,7.837,18.522ZM2.185,13a3.919,3.919,0,0,1,1.071-2.467,3.285,3.285,0,0,1,4.722,0A3.957,3.957,0,0,1,9.049,13c.021.3.035.634.042,1V14.1a4.79,4.79,0,0,0-2.608-1.91,6.721,6.721,0,0,0-2.009-.317.549.549,0,0,0-.366.162l-.951.987a.528.528,0,0,0,.761.733l.8-.825c.684.035,2.883.289,3.735,2.171a2.861,2.861,0,0,1-5.688-.444.532.532,0,0,0-.529-.529.343.343,0,0,0-.085.007A.853.853,0,0,1,2.157,14C2.157,13.638,2.164,13.292,2.185,13Zm-.493,4.426a6.081,6.081,0,0,0,.3-1.269,3.927,3.927,0,0,0,1.4,1.72v.634A3.781,3.781,0,0,1,1.691,17.429Zm3.122,2.516L4.32,19.48a1.07,1.07,0,0,0,.127-.514V18.4a3.972,3.972,0,0,0,2.34,0v.564a1.07,1.07,0,0,0,.127.514l-.493.465A1.162,1.162,0,0,1,4.814,19.945Zm8.112-10V8.634a.688.688,0,0,0-.049-.233,5.1,5.1,0,0,1-.514-2.22V5.053a4,4,0,0,1,4-4h7.386V6.181A5,5,0,0,1,23.23,8.4a.511.511,0,0,0-.049.233v1.508a5.065,5.065,0,0,1-1.621,3.735c-.134.12-.268.24-.409.345l-.007.007a5.084,5.084,0,0,1-3.432,1.022A5.242,5.242,0,0,1,12.926,9.945ZM17.641,16.3c.141.007.275.014.416.014a6.125,6.125,0,0,0,2.854-.7v.966L18.05,18.536l-2.861-1.959V15.59A5.826,5.826,0,0,0,17.641,16.3ZM15.9,20.58c-.007.007-.014.014-.028.007s-.021-.014-.028-.014L14.2,18.106l.529-.557,2.495,1.706Zm4.356-.007c0,.007-.007.014-.028.014a.073.073,0,0,1-.028-.007l-1.325-1.325,2.495-1.706.529.557Zm6.787-6.054v-.987a.569.569,0,0,0-.056-.24l-.324-.655a1.742,1.742,0,0,1-.183-.775v-.028a2.3,2.3,0,0,1,2.3-2.3h4.56v2.192a2.37,2.37,0,0,1-.24,1.029l-.268.536a.545.545,0,0,0-.056.24V14.66a2.853,2.853,0,0,1-2.946,2.854A2.955,2.955,0,0,1,27.043,14.519Zm2.742,4.06h.12a4.007,4.007,0,0,0,1.163-.176v.211a1.493,1.493,0,0,0,.035.31L29.9,20.129l-1.2-1.2a1.406,1.406,0,0,0,.035-.317v-.226A3.783,3.783,0,0,0,29.784,18.578Z"
                  transform="translate(2.235)"
                ></path>
                <line
                  id="Line_6"
                  data-name="Line 6"
                  stroke="#fff"
                  x2="40.225"
                  transform="translate(0 26.211)"
                ></line>
              </g>
            </svg>
            <h2>Authorised Dealership</h2>
          </div>
        </div>
      </div>
      <AboutSection home={true} />
      <AboutSection1 home={true} />
      <HomeProduct />
      <HomeBottom />
      <Footer />
      <Whatsapp comp={true}/>
    </>
  );
}

function Maincarousel(props) {
  return (
    <>
      <Carousel
        stopOnHover={false}
        className="carousel"
        showArrows={false}
        showIndicators={false}
        showThumbs={false}
        autoPlay={true}
        showStatus={false}
        selectedItem={props.currentSlide}
        infiniteLoop={true}
        interval={5000}
      >
        <div className="carousel-img">
          <img src={"/assets/carousel/img-1.jpg"} alt="img1" />
        </div>
        <div className="carousel-img">
          <img src={"/assets/carousel/img-2.jpg"} alt="img2" />
        </div >
        <div className="carousel-img">
          <img src={"/assets/carousel/img-3.jpg"} alt="img3" />
        </div>
      </Carousel>
    </>
  );
}

function TextCarousel(props) {
  return (
    <Carousel
      stopOnHover={false}
      showArrows={false}
      showIndicators={false}
      showThumbs={false}
      showStatus={false}
      selectedItem={props.currentSlide}
      onChange={props.update}
      infiniteLoop={true}
      autoPlay={true}
    >
      <div className="text-carousel">
        <h2>
          Innovative,
          <br /> Informative,
          <br /> Inspiring!
        </h2>
        <p>
          Discover the Hyderabad’s leading resource for designing and building
          with wood
        </p>
      </div>
      <div className="text-carousel-1">
        <h2>HIGH GRADE HARDWOOD TIMBER SUPPLIERS IN HYDERABAD</h2>
        <p>
          Choose from a variety of wood ranging from Teak and Sal Wood to
          pinewood, we have it all.
        </p>
      </div>
      <div className="text-carousel-2">
        <h2>
          Framing <br />
          Crafting
          <br /> Engineering
        </h2>

        <p>
          Wooden Laminated Doors, Teak Wood Doors, WPC Door, WPC Window Frame,
          Packaging Boxes, Crates, etc.
        </p>
      </div>
    </Carousel>
  );
}
function HomeBottom() {
  function scrollright() {
    let far = ($(".work-img-scroll").width() / 2) * -1;
    let pos = $(".work-img-scroll").scrollLeft() + far;
    $(".work-img-scroll").animate({ scrollLeft: pos }, 1000);
  }
  function scrollLeft() {
    let far = ($(".work-img-scroll").width() / 2) * 1;
    let pos = $(".work-img-scroll").scrollLeft() + far;
    $(".work-img-scroll").animate({ scrollLeft: pos }, 1000);
  }
  return (
    <div className="home-bottom">
      <div className="home-bottom-container">
        <div className="our-works">
          <h3>
            <Slide right>Our Works</Slide>
          </h3>
          <div className="scroll-container">
            <button className="scroll-left" onClick={scrollright}>
              <svg
                width="55"
                height="55"
                viewBox="0 0 100 99"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  r="49"
                  transform="matrix(-1 0 0 1 49.5029 49.5)"
                  fill="#EDB76D"
                  stroke="#E69D39"
                />
                <line
                  y1="-1.5"
                  x2="38.9981"
                  y2="-1.5"
                  transform="matrix(-0.707107 0.707107 0.707107 0.707107 61.5435 22.7432)"
                  stroke="#434343"
                  stroke-width="3"
                />
                <line
                  y1="-1.5"
                  x2="38.9981"
                  y2="-1.5"
                  transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 59.6619 76.2568)"
                  stroke="#434343"
                  stroke-width="3"
                />
              </svg>
            </button>
            <div className="work-img-scroll">
              <div className="work-img-1">
                <img src={"/assets/our-works/img-1.jpg"} alt="img1" />
              </div>
              <div className="work-img-1">
                {" "}
                <img src={"/assets/our-works/img-2.jpg"} alt="img1" />
              </div>
              <div className="work-img-1">
                <img src={"/assets/our-works/img-3.jpg"} alt="img1" />
              </div>
              <div className="work-img-1">
                <img src={"/assets/our-works/img-4.jpg"} alt="img1" />
              </div>
              <div className="work-img-1">
                {" "}
                <img src={"/assets/our-works/img-5.jpg"} alt="img1" />
              </div>
              <div className="work-img-1">
                {" "}
                <img src={"/assets/our-works/img-6.jpg"} alt="img1" />
              </div>
              <div className="work-img-1">
                {" "}
                <img src={"/assets/our-works/img-7.jpg"} alt="img1" />
              </div>
              <div className="work-img-1">
                {" "}
                <img src={"/assets/our-works/img-8.jpg"} alt="img1" />
              </div>
            </div>
            <button className="scroll-right" onClick={scrollLeft}>
              <svg
                width="55"
                height="55"
                viewBox="0 0 100 99"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="49.5029"
                  cy="49.5"
                  r="49"
                  fill="#EDB76D"
                  stroke="#E69D39"
                />
                <line
                  x1="38.5231"
                  y1="21.6825"
                  x2="66.0989"
                  y2="49.2583"
                  stroke="#434343"
                  stroke-width="3"
                />
                <line
                  x1="38.2833"
                  y1="75.1962"
                  x2="65.8592"
                  y2="47.6203"
                  stroke="#434343"
                  stroke-width="3"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="why-us">
          <h3 id="why-us">
            <Slide right>Why Us?</Slide>
          </h3>
          <Fade bottom>
            <h5>We guarantee quality and compliance with deadlines!</h5>
            <div className="why-us-det">
              <div className="det-container">
                <div className="det-row">
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 61 60"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0)">
                      <path
                        d="M6.71998 19.4717H1.49666C0.694975 19.4717 0.045166 20.1215 0.045166 20.9232C0.045166 21.7248 0.694975 22.3746 1.49666 22.3746H6.71986C7.52165 22.3746 8.17147 21.7248 8.17147 20.9232C8.17147 20.1215 7.52165 19.4717 6.71998 19.4717Z"
                        fill="white"
                      />
                      <path
                        d="M58.5098 19.4717H53.2865C52.4849 19.4717 51.835 20.1215 51.835 20.9232C51.835 21.7248 52.4849 22.3746 53.2865 22.3746H58.5098C59.3112 22.3746 59.9611 21.7248 59.9611 20.9232C59.9611 20.1215 59.3112 19.4717 58.5098 19.4717Z"
                        fill="white"
                      />
                      <path
                        d="M12.6998 38.2262C12.1329 37.6593 11.2139 37.6593 10.647 38.2262L6.84773 42.0254C6.2809 42.5923 6.2809 43.5112 6.84773 44.0781C7.13122 44.3615 7.50269 44.5034 7.87407 44.5034C8.24544 44.5034 8.61704 44.3615 8.9004 44.0781L12.6998 40.2789C13.2666 39.7123 13.2666 38.7931 12.6998 38.2262Z"
                        fill="white"
                      />
                      <path
                        d="M50.501 0.425129C49.9339 -0.14171 49.0152 -0.14171 48.4481 0.425129L44.753 4.1203C44.1862 4.68715 44.1862 5.60626 44.753 6.17297C45.0367 6.45622 45.408 6.59801 45.7795 6.59801C46.151 6.59801 46.5223 6.45622 46.8058 6.17285L50.5008 2.47781C51.0677 1.91096 51.0677 0.991851 50.501 0.425129Z"
                        fill="white"
                      />
                      <path
                        d="M15.2514 4.11801L11.5582 0.424954C10.9914 -0.141651 10.0723 -0.141651 9.50545 0.424954C8.93861 0.991793 8.93861 1.9109 9.50545 2.47773L13.1986 6.17093C13.4821 6.45429 13.8536 6.59609 14.225 6.59609C14.5963 6.59609 14.9679 6.45429 15.2513 6.17093C15.8181 5.60409 15.8181 4.68499 15.2514 4.11801Z"
                        fill="white"
                      />
                      <path
                        d="M53.1574 42.0254L49.3724 38.2399C48.8053 37.6733 47.8866 37.6733 47.3194 38.2401C46.7526 38.807 46.7526 39.726 47.3194 40.2929L51.1047 44.0781C51.3882 44.3616 51.7597 44.5032 52.1312 44.5032C52.5027 44.5032 52.874 44.3613 53.1574 44.0781C53.7243 43.5113 53.7243 42.5923 53.1574 42.0254Z"
                        fill="white"
                      />
                      <path
                        d="M30.0015 3.94189C19.9646 3.94189 11.7991 12.4831 11.7991 22.9819C11.7991 27.8627 13.5474 33.1165 16.5959 37.396C18.9372 40.6825 20.1746 44.3394 20.1746 47.9711V57.0971C20.1746 58.6979 21.4769 60.0001 23.0776 60.0001H36.9255C38.5263 60.0001 39.8286 58.6979 39.8286 57.0971V47.9711C39.8286 44.3394 41.066 40.6825 43.407 37.396C46.4557 33.1168 48.2041 27.8627 48.2041 22.9819C48.2039 12.4831 40.0383 3.94189 30.0015 3.94189ZM36.9253 57.0973H23.0774V55.1989H30.0015C30.8031 55.1989 31.4531 54.549 31.4531 53.7474C31.4531 52.9456 30.8031 52.2959 30.0015 52.2959H23.0774V50.3975H36.9258L36.9275 57.0971C36.9272 57.0973 36.9267 57.0973 36.9253 57.0973ZM27.9661 30.0169L26.025 25.87H33.9781L32.0372 30.0169C31.9607 30.1801 31.9153 30.3563 31.9033 30.5361L30.7777 47.4945H29.2254L28.0998 30.5361C28.0878 30.3563 28.0422 30.1801 27.9661 30.0169ZM41.0425 35.7119C38.45 39.3513 37.0338 43.4149 36.9313 47.4945H33.6872L34.7819 31.0002L37.5745 25.0336C37.785 24.5841 37.7511 24.058 37.4845 23.6392C37.2183 23.2205 36.7563 22.9668 36.2598 22.9668H23.7429C23.2465 22.9668 22.7846 23.2205 22.5182 23.6392C22.2518 24.058 22.2178 24.5841 22.4283 25.0336L25.2212 31.0002L26.3159 47.4942H23.0713C22.9689 43.4147 21.5528 39.351 18.9601 35.7117C16.2936 31.9684 14.7017 27.2097 14.7017 22.9818C14.7017 14.0837 21.5651 6.84474 30.0013 6.84474C38.4373 6.84474 45.3008 14.0837 45.3008 22.9818C45.3011 27.2099 43.7091 31.9686 41.0425 35.7119Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect
                          width="60"
                          height="60"
                          fill="white"
                          transform="translate(0.00292969)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <h4>DESIGN</h4>{" "}
                </div>
                <p>
                  <Fade bottom>
                    We are a team of creatives who offer an unmatched level of
                    experience and commitment to creating luxury wooden designs
                    for your high-end property.We bring this commitment to every
                    project we handle, including yours.
                  </Fade>
                </p>
              </div>{" "}
              <div className="det-container">
                <div className="det-row">
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 59 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M54.331 32.245C53.4909 32.245 52.8094 32.9251 52.8094 33.7639V60.8234H36.4832V43.8372C36.4832 42.9984 35.8019 42.3181 34.9619 42.3181H23.0437C22.2036 42.3181 21.5223 42.9984 21.5223 43.8372V57.3059C21.5223 58.1446 22.2036 58.8247 23.0437 58.8247C23.8838 58.8247 24.5651 58.1446 24.5651 57.3059V45.356H33.4403V60.8234H5.19576V23.6469L29.0026 4.60086L53.3793 24.1027C54.0349 24.6275 54.9926 24.5218 55.518 23.8673C56.0434 23.2127 55.9378 22.2571 55.2822 21.7324L29.9538 1.46902C29.398 1.024 28.607 1.024 28.0512 1.46902L2.72288 21.7324C2.36254 22.0207 2.15283 22.4563 2.15283 22.9176V62.342C2.15283 63.1805 2.83395 63.8608 3.6743 63.8608H54.331C55.1712 63.8608 55.8525 63.1805 55.8525 62.342V33.7639C55.8525 32.9249 55.1712 32.245 54.331 32.245Z"
                      fill="white"
                    />
                  </svg>
                  <h4>CONSTRUCTION</h4>{" "}
                </div>
                <p>
                  <Fade bottom>
                    One of our primary goals is to help you create excellent
                    products that stand out. Our next generation hard-wax
                    Oiling, Matt Lacquering and Paint finishes mixed to any RAL
                    color of your choice will achieve this and more.
                  </Fade>
                </p>
              </div>{" "}
              <div className="det-container">
                <div className="det-row">
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 38 61"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0)">
                      <path
                        d="M36.0707 19.0084C35.4089 18.8542 34.747 19.2573 34.5936 19.9211L31.4146 33.3751V14.3261C31.4146 7.19018 25.6241 1.38184 18.51 1.38184C11.3959 1.38184 5.6054 7.19018 5.6054 14.3261V33.3868L2.42652 19.9329C2.2729 19.2691 1.59931 18.8542 0.94935 19.0202C0.287577 19.1743 -0.126033 19.8381 0.039411 20.5019L4.47094 39.2189V39.2309V39.2546C4.60092 39.7999 5.08545 40.2029 5.6645 40.2029H17.2692V51.8433H7.48437C6.79896 51.8433 6.25536 52.4003 6.25536 53.0759V58.2206C6.25536 58.9082 6.81078 59.4532 7.48437 59.4532C8.15797 59.4532 8.71338 58.8962 8.71338 58.2206V54.3088H28.2829V58.2206C28.2829 58.9082 28.8383 59.4532 29.512 59.4532C30.1973 59.4532 30.741 58.8962 30.741 58.2206V53.0759C30.741 52.3886 30.1856 51.8433 29.512 51.8433H19.7272V40.2029H31.3319C31.9109 40.2029 32.3953 39.7999 32.5255 39.2546V39.2309V39.2189L36.957 20.5019C37.1461 19.8381 36.7324 19.1743 36.0707 19.0084ZM8.07524 14.3261C8.07524 8.55335 12.7549 3.85927 18.51 3.85927C24.2651 3.85927 28.9448 8.55335 28.9448 14.3261V31.3362C28.1647 30.8503 25.9195 28.9774 18.51 28.9774C11.2541 28.9774 9.127 30.7791 8.07524 31.3362V14.3261ZM30.0439 37.7255H18.51H6.97623C7.37801 33.0433 12.4004 31.4429 16.1938 31.4429H18.51H20.838C24.6197 31.4549 29.6419 33.055 30.0439 37.7255Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect
                          width="37"
                          height="61"
                          fill="white"
                          transform="translate(0.00292969)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <h4>CUSTOM DESIGNS</h4>{" "}
                </div>
                <p>
                  <Fade bottom>
                    At Ravani Timber, we believe one of the best ways to achieve
                    best product finishes is through custom designs. Thus, all
                    our products are designed and hand-crafted by our in-house
                    team to provide a pure unique applied finish that helps it
                    stand out.
                  </Fade>
                </p>
              </div>
            </div>
            <div className="home-contact-bottom">
              <a href="/contactus" className="home-cont-row">
                <h1>CONTACT US?</h1>
                <i>
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 71 71"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="35.5"
                      cy="35.5"
                      r="35"
                      fill="#EDB76D"
                      stroke="#E69D39"
                    />
                    <line
                      x1="27.9255"
                      y1="15.2499"
                      x2="47.7021"
                      y2="35.0265"
                      stroke="#434343"
                      stroke-width="3"
                    />
                    <line
                      x1="27.1536"
                      y1="53.6288"
                      x2="46.9302"
                      y2="33.8522"
                      stroke="#434343"
                      stroke-width="3"
                    />
                  </svg>
                </i>
              </a>
              <a href="tel:9441522211" className="tel-bottom">
                <FontAwesomeIcon icon={faPhoneAlt} /> +91 9441522211
              </a>
              <a href="tel:9848441991" className="tel-bottom">
                <FontAwesomeIcon icon={faPhoneAlt} /> +91 9848441991
              </a>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
}

function HomeProduct() {
  return (
    <div className="home-product">
      <div className="home-products-container">
        <h3>
          <Slide right>Our Products</Slide>
        </h3>
        <div className="product-row">
          <div className="product-preview-container">
            <div className="product-preview">
              <img src={"/assets/img-1.jpg"} alt="img1" />
            </div>
          </div>
          <div className="product-grid">
            <Fade bottom>
              <a href="products/#wood-section">
                <div className="product-grid-child">
                  <h2>Timbers</h2>
                  <div className="grid-child">
                    <img src={"/assets/home-product/img-1.jpg"} alt="img1" />
                  </div>
                </div>
              </a>
            </Fade>
            <Fade bottom>
              <a href="products/#door-section">
                <div className="product-grid-child">
                  <h2>Doors</h2>
                  <div className="grid-child">
                    <img src={"/assets/home-product/img-2.jpg"} alt="img1" />
                  </div>
                </div>
              </a>
            </Fade>
            <Fade bottom>
              <a href="products/#frame-section">
                <div className="product-grid-child">
                  <h2>Frames & Shutters</h2>
                  <div className="grid-child">
                    <img src={"/assets/home-product/img-3.jpg"} alt="img1" />
                  </div>
                </div>
              </a>
            </Fade>
            <Fade bottom>
              <a href="products/#pack-section">
                <div className="product-grid-child">
                  <h2>Packaging</h2>
                  <div className="grid-child">
                    <img src={"/assets/home-product/img-4.jpg"} alt="img1" />
                  </div>
                </div>
              </a>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
}

export function AboutSection(prop) {
  return (
    <>
      <div class="about-section">
        <div className="about-section-container">
          {" "}
          <Fade bottom>
            <div className="about-img-1">
              <img src={"/assets/about/img-1.jpg"} alt="img1" />
            </div>
          </Fade>
          <Fade bottom>
            <div className="about-img-2">
              <img src={"/assets/about/img-2.jpg"} alt="img1" />
            </div>
          </Fade>
          <div className="about-section-box">
            <Fade bottom>
              <h3>About Us</h3>
            </Fade>
            <Fade bottom>
              <p>
                Ravani Timbers is established in the year 1997 and it is well
                reputed dealer for all types of Teak Wood, Sal Wood, Log & Cut
                Sizes, Manufactures of Doors & Windows, Frames & Shutters, the
                major marketing area is all over india.
                <span>
                  <a
                    href="/aboutus"
                    className={prop.home ? "" : "read-more-false"}
                  >
                    read more
                    <svg
                      width="24"
                      height="10"
                      viewBox="0 0 24 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.9107 8.70711C23.3012 8.31658 23.3012 7.68342 22.9107 7.29289L16.5467 0.928932C16.1562 0.538408 15.5231 0.538408 15.1325 0.928932C14.742 1.31946 14.742 1.95262 15.1325 2.34315L20.7894 8L15.1325 13.6569C14.742 14.0474 14.742 14.6805 15.1325 15.0711C15.5231 15.4616 16.1562 15.4616 16.5467 15.0711L22.9107 8.70711ZM0 9H22.2036V7H0V9Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </span>
              </p>
            </Fade>
          </div>
        </div>
        <canvas className="about-section-canvas "></canvas>
      </div>
    </>
  );
}
export function AboutSection1(prop) {
  return (
    <>
      <div class="about-section1">
        <div className="about-section-container1">
          {" "}
          <Fade bottom>
            <div className="about-img-1-1">
              <img src={"/assets/about/img-1.jpg"} alt="img1" />
            </div>
          </Fade>
          <Fade bottom>
            <div className="about-img-2-1">
              <img src={"/assets/about/img-2.jpg"} alt="img1" />
            </div>
          </Fade>
          <div className="about-section-box1">
            <Fade bottom>
              <h3>About Us</h3>
            </Fade>
            <p>
              Ravani Timbers is established in the year 1997 and it is well
              reputed dealer for all types of Teak Wood, Sal Wood, Log & Cut
              Sizes, Manufactures of Doors & Windows, Frames & Shutters, the
              major marketing area is all over india.
              <span>
                <a
                  href="/aboutus"
                  className={prop.home ? "" : "read-more-false"}
                >
                  read more
                  <svg
                    width="24"
                    height="10"
                    viewBox="0 0 24 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22.9107 8.70711C23.3012 8.31658 23.3012 7.68342 22.9107 7.29289L16.5467 0.928932C16.1562 0.538408 15.5231 0.538408 15.1325 0.928932C14.742 1.31946 14.742 1.95262 15.1325 2.34315L20.7894 8L15.1325 13.6569C14.742 14.0474 14.742 14.6805 15.1325 15.0711C15.5231 15.4616 16.1562 15.4616 16.5467 15.0711L22.9107 8.70711ZM0 9H22.2036V7H0V9Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
export default Home;
